/**************
 Sign In Modal
 ***************/

// listen for sign in link
document.querySelectorAll(".signInContentBtn").forEach(function (el) {
    el.addEventListener("click", function (event) {
        // prevent default
        event.preventDefault();

        // set local storage to redirect to the page the user was on after sign in
        localStorage.setItem("redirect_on_login", window.location.href);

        // log local storage
        // continue to link they clicked
        window.location.href = this
    });
});


// close sign in
function closeSignIn() {
    document.querySelector("#signIn").close();
    document.querySelector("body").classList.remove("noScroll");
}

//close sign in listener
document.querySelectorAll(".closeSignIn").forEach(function (el) {
    el.addEventListener("click", function () {
        closeSignIn();
    });
});

document.querySelector("#signIn").addEventListener("click", function (e) {
    if (e.target === this) {
        closeSignIn();
    }
})

// open sign in dialog
document.querySelectorAll(".openSignIn").forEach(function (el) {
    el.addEventListener("click", function () {
        document.querySelector("#signIn").showModal();
        document.querySelector("body").classList.add("noScroll");


    });
});
